import React, { useState } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, ReferenceLine, Cell } from 'recharts';
import { ChevronDown, TrendingUp, TrendingDown, Target, Info } from 'lucide-react';
const data = [{
  name: 'Week 1',
  cost: 21.5,
  plan: 22
}, {
  name: 'Week 2',
  cost: 23.2,
  plan: 22
}, {
  name: 'Week 3',
  cost: 20.8,
  plan: 22
}, {
  name: 'Week 4',
  cost: 22.1,
  plan: 22
}, {
  name: 'Week 5',
  cost: 21.9,
  plan: 22
}];
export function PnLView() {
  const [selectedWeek, setSelectedWeek] = useState('Week 1');
  return <div className="space-y-6" data-id="element-620">
      <div className="flex items-center justify-between" data-id="element-621">
        <div data-id="element-622">
          <h2 className="text-2xl font-bold text-slate-900" data-id="element-623">P&L Recap</h2>
          <p className="text-sm text-slate-500" data-id="element-624">
            Weekly and monthly profit and loss performance
          </p>
        </div>
        <div className="relative" data-id="element-625">
          <select value={selectedWeek} onChange={e => setSelectedWeek(e.target.value)} className="appearance-none pl-4 pr-10 py-2 bg-white border border-slate-200 rounded-xl text-sm font-bold focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 outline-none transition-all cursor-pointer shadow-sm" data-id="element-626">
            <option data-id="element-627">Week 1</option>
            <option data-id="element-628">Week 2</option>
            <option data-id="element-629">Week 3</option>
            <option data-id="element-630">Week 4</option>
            <option data-id="element-631">Week 5</option>
          </select>
          <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none" size={16} data-id="element-632" />
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-633">
        {/* Recap Table */}
        <div className="lg:col-span-2 bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden" data-id="element-634">
          <div className="p-6 border-b border-slate-50 flex items-center justify-between" data-id="element-635">
            <h3 className="text-sm font-bold text-slate-900 uppercase tracking-wider" data-id="element-636">
              Performance Recap
            </h3>
            <div className="flex gap-4" data-id="element-637">
              <div className="flex items-center gap-1.5" data-id="element-638">
                <div className="w-2 h-2 bg-emerald-500 rounded-full" data-id="element-639" />
                <span className="text-[10px] font-bold text-slate-400 uppercase" data-id="element-640">
                  Current Week
                </span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-641">
                <div className="w-2 h-2 bg-blue-500 rounded-full" data-id="element-642" />
                <span className="text-[10px] font-bold text-slate-400 uppercase" data-id="element-643">
                  MTD
                </span>
              </div>
            </div>
          </div>
          <div className="overflow-x-auto" data-id="element-644">
            <table className="w-full text-left" data-id="element-645">
              <thead data-id="element-646">
                <tr className="bg-slate-50/50" data-id="element-647">
                  <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-648">
                    Metric
                  </th>
                  <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-649">
                    Current Week
                  </th>
                  <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-650">
                    MTD
                  </th>
                  <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-651">
                    Variance
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-50" data-id="element-652">
                <RecapRow label="Food Sales" current="$12,450" mtd="$48,200" variance="+4.2%" isPositive data-id="element-653" />
                <RecapRow label="COGS" current="$2,714" mtd="$10,507" variance="-1.2%" isPositive data-id="element-654" />
                <RecapRow label="Food Cost %" current="21.8%" mtd="21.8%" variance="-0.2%" isPositive data-id="element-655" />
                <RecapRow label="Plan (Target)" current="22.0%" mtd="22.0%" variance="0.0%" data-id="element-656" />
              </tbody>
            </table>
          </div>
        </div>

        {/* Plan Info */}
        <div className="bg-slate-900 rounded-2xl p-6 text-white shadow-xl" data-id="element-657">
          <div className="flex items-center gap-2 mb-8" data-id="element-658">
            <Target className="text-slate-400" size={20} data-id="element-659" />
            <h3 className="text-sm font-bold uppercase tracking-wider" data-id="element-660">
              Profit Target
            </h3>
          </div>
          <div className="space-y-6" data-id="element-661">
            <div className="text-center py-4" data-id="element-662">
              <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1" data-id="element-663">
                Net Profit Variance
              </p>
              <p className="text-4xl font-black" data-id="element-664">+1.4%</p>
              <p className="text-xs font-bold text-emerald-400 mt-2" data-id="element-665">
                ABOVE TARGET (GOOD)
              </p>
            </div>
            <div className="p-4 bg-white/5 rounded-xl border border-white/10" data-id="element-666">
              <div className="flex items-start gap-3" data-id="element-667">
                <Info size={16} className="text-slate-400 shrink-0 mt-0.5" data-id="element-668" />
                <p className="text-[10px] text-slate-300 leading-relaxed font-medium" data-id="element-669">
                  Your net profit is currently trending 1.4% above the monthly
                  target. This is driven by strong food sales and efficient
                  labor management.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Visual Chart - Revenue Trend */}
        <div className="lg:col-span-3 bg-white p-6 rounded-2xl border border-slate-100 shadow-sm" data-id="element-670">
          <h3 className="text-sm font-bold text-slate-900 uppercase tracking-wider mb-8" data-id="element-671">
            Weekly Revenue Trend
          </h3>
          <div className="h-80 w-full" data-id="element-672">
            <ResponsiveContainer width="100%" height="100%" data-id="element-673">
              <BarChart data={data} margin={{
              top: 20,
              right: 30,
              left: 0,
              bottom: 0
            }} data-id="element-674">
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#F1F5F9" data-id="element-675" />
                <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{
                fontSize: 10,
                fontWeight: 700,
                fill: '#94A3B8'
              }} dy={10} data-id="element-676" />
                <YAxis axisLine={false} tickLine={false} tick={{
                fontSize: 10,
                fontWeight: 700,
                fill: '#94A3B8'
              }} data-id="element-677" />
                <Tooltip cursor={{
                fill: '#F8FAFC'
              }} contentStyle={{
                borderRadius: '12px',
                border: 'none',
                boxShadow: '0 10px 15px -3px rgb(0 0 0 / 0.1)'
              }} data-id="element-678" />
                <Bar dataKey="cost" radius={[6, 6, 0, 0]} barSize={40} fill="#6366F1" data-id="element-679" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>;
}
function RecapRow({
  label,
  current,
  mtd,
  variance,
  isPositive
}: any) {
  return <tr className="hover:bg-slate-50 transition-colors" data-id="element-680">
      <td className="px-6 py-4 text-sm font-bold text-slate-700" data-id="element-681">{label}</td>
      <td className="px-6 py-4 text-sm font-black text-slate-900" data-id="element-682">{current}</td>
      <td className="px-6 py-4 text-sm font-black text-slate-900" data-id="element-683">{mtd}</td>
      <td className="px-6 py-4" data-id="element-684">
        <div className={`flex items-center gap-1 text-xs font-bold ${variance === '0.0%' ? 'text-slate-400' : isPositive ? 'text-emerald-600' : 'text-rose-600'}`} data-id="element-685">
          {variance !== '0.0%' && (isPositive ? <TrendingDown size={14} data-id="element-686" /> : <TrendingUp size={14} data-id="element-687" />)}
          {variance}
        </div>
      </td>
    </tr>;
}